module.exports = __webpack_public_path__ + "img/yakitori.f8fcb781.png";